let current = 1,
  playPauseBool = true,
  interval;

const slideList = document.querySelectorAll('.slide');
const slides = Array.from(slideList);
const heroBgSlideLists = document.querySelectorAll('.herobg-slide');
const heroBgSlides = Array.from(heroBgSlideLists);

let slideLength = document.querySelectorAll('.slide').length;
//console.log('slidelength:' + slideLength);

const backgroundBg = document.querySelector('.hero_box_bg');

// const nameLists = document.querySelectorAll('.hero_name_list__link');
// const lists = Array.from(nameLists);

const changeSlides = () => {
  //console.log(current);
  if (current > slides.length) {
    current = 1;
  } else if (current === 0) {
    current = slides.length;
  }

  slides.forEach((slide) => {
    //  console.log(slide.classList[0]);
    if (slide.classList[1].split('-')[1] * 1 === current) {
      slide.style.cssText = 'visibility: visible; opacity: 1';
      //   console.log(slide.dataset.herobg);
      // let bg = slide.dataset.herobg;
      // backgroundBg.style.backgroundImage = `url(${bg})`;
    } else {
      slide.style.cssText = 'visibility: hidden; opacity: 0';
    }
  });
};

// const arrowVisibility = () => {
//   const arrows = document.querySelectorAll('.control');
//   Array.from(arrows).forEach((arrow) => {
//     if (!playPauseBool) {
//       arrow.classList.add('arrows-visibility');
//     } else {
//       arrow.classList.remove('arrows-visibility');
//     }
//   });
// };

// const changePlayPause = () => {
//   const i = document.querySelector('.play-pause');
//   if (i.className === 'play-pause') {
//     console.log('has class');
//     i.textContent = 'pause';
//   } else {
//     i.textContent = 'play';
//     console.log('play');
//   }
//   // const i = document.querySelector('.play-pause i');
//   // const cls = i.classList[1];
//   // if (cls === 'fa-play') {
//   //   i.classList.remove('fa-play');
//   //   i.classList.add('fa-pause');
//   // } else {
//   //   i.classList.remove('fa-pause');
//   //   i.classList.add('fa-play');
//   // }
// };

const playPause = () => {
  if (playPauseBool) {
    interval = setInterval(() => {
      NameListRemoveActive();
      current++;

      changeSlides();
      NameListActive();
    }, 5000);
    // playPauseBool = false;//自動再生フラグ
  } else {
    clearInterval(interval);
    playPauseBool = true;
  }
  //arrowVisibility();

  //changePlayPause();
};

//seriesリストのクラス
const NameListActive = () => {
  slideList[current - 1].classList.add('active');
  //nameLists[current - 1].classList.add('active');
  heroBgSlides[current - 1].classList.add('active');

  // console.log(current);
};

function NameListRemoveActive() {
  slideList.forEach((list) => {
    list.classList.remove('active');
  });
  // nameLists.forEach((list) => {
  //   list.classList.remove('active');
  // });
  heroBgSlides.forEach((list) => {
    list.classList.remove('active');
  });
}

// document.querySelector('.left-arrow').addEventListener('click', () => {
//   if (!playPauseBool) {
//     playPause();
//   }
//   current--;
//   changeSlides();
// });

// document.querySelector('.right-arrow').addEventListener('click', () => {
//   if (!playPauseBool) {
//     playPause();
//   }
//   current++;
//   changeSlides();
// });

// document.querySelector('.play-pause').addEventListener('click', () => {
//   playPause();
//   console.log('playpause click');
// });

changeSlides();
playPause();
NameListActive();
////
// const myDelay = 7000;
